import { useQuery } from "@tanstack/react-query";
import { useClient } from "../../hooks/useClient";
import { useDefinition } from "../../hooks/useDefinition";
import { useErrorHandling } from "../../hooks/useErrorHandling";

export function useDesigns() {
	const client = useClient();
	const definition = useDefinition();
	const { createErrorHandler } = useErrorHandling();

	const loadDesignsAsync = () => {
		if (!definition) {
			return [];
		}

		const {
			product: { code, aspectRatio, showDesigns },
			theme,
		} = definition;
		const designs = client.loadAlternativeDesignsAsync(code, aspectRatio, theme);

		designs
			.then((d) => {
				if ((!d || !d.length) && showDesigns) {
					// log ProductWarning to server
					client.logErrorAsync(
						new eXpress.ProductWarning(
							"ShowDesignsTab is set to True but no designs were found",
							`No designs found for product ${definition.product.code}`,
						),
						false,
					);
				}
			})
			.catch(createErrorHandler());

		return designs;
	};

	return useQuery(
		["designs", definition?.product.code, definition?.product.aspectRatio],
		loadDesignsAsync,
	);
}
